module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-history-selected@3x.png?0.0.53";